import { render, staticRenderFns } from "./DisplayNumber.vue?vue&type=template&id=2f8b014e&scoped=true&"
import script from "./DisplayNumber.vue?vue&type=script&lang=js&"
export * from "./DisplayNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b014e",
  null
  
)

export default component.exports